export default "__VITE_ASSET__YGBxr5lX__"